import React from 'react';
import { Section } from './prose';

export default function RefundsContent() {
  return (
    <div data-testid="refunds-content">
      <Section title="The free tier">
        <p>
          The Coach Rands free tracker and strength calculator are free to use. We do not charge for them and we do
          not take any payment details, so there is nothing to refund.
        </p>
      </Section>
      <Section title="Paid services">
        <p>
          We do not sell anything through this app at the moment. If we start charging for anything, this page will
          set out our refund policy before you can pay.
        </p>
      </Section>
      <Section title="Questions">
        <p>Email us at [CONTACT EMAIL].</p>
      </Section>
    </div>
  );
}
